/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Product_OversizeInputs */

const tr_landing_shortcuts_mock_product_oversize = /** @type {(inputs: Landing_Shortcuts_Mock_Product_OversizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tişört Oversize · Beyaz`)
};

const en_landing_shortcuts_mock_product_oversize = /** @type {(inputs: Landing_Shortcuts_Mock_Product_OversizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversize T-Shirt · White`)
};

const de_landing_shortcuts_mock_product_oversize = /** @type {(inputs: Landing_Shortcuts_Mock_Product_OversizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversize T-Shirt · Weiß`)
};

const ru_landing_shortcuts_mock_product_oversize = /** @type {(inputs: Landing_Shortcuts_Mock_Product_OversizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Футболка оверсайз · Белая`)
};

/**
* | output |
* | --- |
* | "Oversize T-Shirt · White" |
*
* @param {Landing_Shortcuts_Mock_Product_OversizeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_product_oversize = /** @type {((inputs?: Landing_Shortcuts_Mock_Product_OversizeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Product_OversizeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_product_oversize(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_product_oversize(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_product_oversize(inputs)
	return tr_landing_shortcuts_mock_product_oversize(inputs)
});